import { Component,ChangeDetectorRef} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform} from 'ionic-angular';
import {EbsWebService} from "../../services/ebsWebService";
import {EbsComponentService} from "../../services/ebsComponentService";

@IonicPage()
@Component({
  selector: 'page-detail-card',
  templateUrl: 'detail.html'
})

export class Detail {
  selectedItem: any;
  title: any;
  pageDetailData: any;
  pageDetailDataProcessed:any;
  _ebsComponentService: any;
  showQRCODE:boolean = true;
  getDetailDataUrl:string = "";
  refreshDetailDataUrl:string = "";

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public _ebsWebService: EbsWebService,
              public loadingCtrl: LoadingController,
              public platform: Platform,
              private cdRef:ChangeDetectorRef) {

    this._ebsComponentService = new EbsComponentService(_ebsWebService);

    if(this.platform.is('core') || this.platform.is('mobileweb')){
      this.showQRCODE = false;
    }

    this.title = navParams.get('caption');
    this.selectedItem = navParams.get('item');
    this.getDetailDataUrl = navParams.get('actionURL');

    this.loadDetailPageData(this.getDetailDataUrl);



  }

  ionViewWillEnter(){
    if (this.refreshDetailDataUrl != "") {
      console.log("refresh");
      let urlParts = this.refreshDetailDataUrl.split("?");
      this.loadDetailPageData(urlParts[0],urlParts[1]);
    }
  }

  loadDetailPageData(url,params = null) {
    if (typeof url != "undefined") {
      let loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
      });
      loading.present();
      let postParams = this.navParams.get('postParams');
      if (params!= null && params != "") {
        postParams = params;
      }
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(postParams);
      this.pageDetailData = this._ebsWebService.postData(url,postPayloadObject).subscribe((res) => {
        this.pageDetailDataProcessed =  this._ebsWebService.prepareWebServiceDataForView(res);
        this.cdRef.detectChanges();
        if (typeof res.RefreshUrl != "undefined" && res.RefreshUrl != null && res.RefreshUrl != "" ) {
          this.refreshDetailDataUrl = res.RefreshUrl;
        }
        this._ebsWebService.setBrowserTabTitle(res.MainTitle);
        loading.dismiss();
      });
    }
  }

  openPage(item) {
    if (typeof item.Action != "undefined" && item.Action != "" && item.Action != null) {
      let navParams = {
        title: item.MainTitle,
        actionURL: item.Action,
        postParams: item.PostParameters
      };
      this._ebsComponentService.navigationController(item,navParams,this.navCtrl);
    } else {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts